import { render } from "./service-diagnostics.vue?vue&type=template&id=0864789c&scoped=true"
const script = {}

import "./service-diagnostics.vue?vue&type=style&index=0&id=0864789c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0864789c"]])

export default __exports__